import Vue from "vue";
import Vuetify from "vuetify/lib";
import { Colors } from "@/components/shared/util";

import "@/styles/main.styl";

Vue.use(Vuetify, {
  theme: {
    error: Colors.Red,
    success: Colors.Green,
    warning: Colors.Yellow
  }
});
